import axios from 'axios';
import config from '../../../config/local'

class ApiService {
  async get(url) {
    try {
      const response = await axios.get(`${config.BASE_URL}${url}`);

      return response;
    } catch (error) {
      console.log(error)
    }
  }
}

export const apiService = new ApiService()